import { render, staticRenderFns } from "./LectureTrackSubjectEntity.vue?vue&type=template&id=63c47610&scoped=true"
import script from "./LectureTrackSubjectEntity.vue?vue&type=script&lang=js"
export * from "./LectureTrackSubjectEntity.vue?vue&type=script&lang=js"
import style0 from "./LectureTrackSubjectEntity.vue?vue&type=style&index=0&id=63c47610&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c47610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c47610')) {
      api.createRecord('63c47610', component.options)
    } else {
      api.reload('63c47610', component.options)
    }
    module.hot.accept("./LectureTrackSubjectEntity.vue?vue&type=template&id=63c47610&scoped=true", function () {
      api.rerender('63c47610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LectureTrackSubjectEntity.vue"
export default component.exports